const BADGE_STYLES = {
    success: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
    error:   'bg-red-50 text-red-600 border border-red-200',
    warning: 'bg-amber-50 text-amber-700 border border-amber-200',
    info:    'bg-blue-50 text-blue-700 border border-blue-200',
    neutral: 'bg-gray-100 text-gray-500 border border-gray-200',
};

export function adminBadgeClass(variant) {
    return `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${BADGE_STYLES[variant] || BADGE_STYLES.neutral}`;
}
